import Tea from 'byted-tea-sdk/es/index-base.min.js';
import warpper from '@byted/image-observer-logger-basic';

export default warpper(Tea);
